import {PartialOrder} from "@apps/daily-menu/interfaces";

export const getOrderItemCount = (orders?: PartialOrder[]): number => {
  return (
    orders?.reduce((allCount: number, currOrder: PartialOrder): number => {
      return (
        allCount +
        currOrder.order_items.reduce((allItems, currItem) => {
          return allItems + currItem.count;
        }, 0)
      );
    }, 0) ?? 0
  );
};
